module.exports = __webpack_public_path__ + "img/qrcode_official.6e8e409c.png";